import React from 'react';
import { UnsavedChangesModalProps } from './UnsavedChangesModal.types';
import WarningModal from '../WarningModal/WarningModal';

export default function UnsavedChangesModal(props: UnsavedChangesModalProps) {
	return (
		<WarningModal
			title="Unsaved Changes"
			content="Are you sure you want to leave this form? You have unsaved changes that will be lost."
			open={props.showWarning}
			handleClose={props.handleCancelNavigation}
			handleConfirm={props.handleConfirmNavigation}
		/>
	);
}
